import { defineComponent as _defineComponent } from 'vue'
import ContactMe from '@/components/common/ContactMe.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  import { useRouter } from 'vue-router/composables'
  import useCourse from '@/composables/useCourse'
  import useIcons from '@/composables/useIcons'
  import useShopifyClient from '@/composables/useShopifyClient'

  import { UserModule } from '@/store/modules/user'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseExamTrialEnded',
  setup(__props) {

  const router = useRouter()
  const { isCourseExamTrialEnded } = useCourse()
  const { arrowRightIndicator } = useIcons()
  const { createShopifyCheckout } = useShopifyClient()

  const routeToExamStartPage = () => {
    router.push({ name: 'ExamStartPage' }).catch(() => {
      return
    })
  }

return { __sfc: true,router, isCourseExamTrialEnded, arrowRightIndicator, createShopifyCheckout, routeToExamStartPage, ContactMe, KetchUpButton, SVGRenderer, useRouter, useCourse, useIcons, useShopifyClient, UserModule }
}

})